<template>
  <section>
    <div class="container">
      <div class="columns">
        <div class="column col-xl-12">
          <button @click="openMenu" @mouseenter="animMenuBtn" @mouseleave="animMenuBtnRev" id="menu_btn">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
              <g id="Layer_1">
                <g>
                  
                    <radialGradient id="SVGID_1_" cx="100.1333" cy="99.9556" r="86" gradientTransform="matrix(1.1628 0 0 1.1628 -16.4341 -16.2274)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0" style="stop-color:#00BED0"/>
                    <stop  offset="0.8587" style="stop-color:#00BED0;stop-opacity:0.2272"/>
                    <stop  offset="1" style="stop-color:#00BED0;stop-opacity:0.1"/>
                  </radialGradient>
                  <circle style="fill:url(#SVGID_1_);" cx="100" cy="100" r="100"/>
                </g>
              </g>
              <g>
                <g>
                  <circle style="fill:#FFFFFF;" cx="100" cy="100" r="82.5"/>
                  <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="17.5" y1="100" x2="182.5" y2="100">
                    <stop  offset="5.618001e-03" style="stop-color:#41354D"/>
                    <stop  offset="0.6101" style="stop-color:#41354D"/>
                    <stop  offset="0.8039" style="stop-color:#41354D"/>
                    <stop  offset="0.8079" style="stop-color:#3F3951"/>
                    <stop  offset="0.8734" style="stop-color:#247287"/>
                    <stop  offset="0.9295" style="stop-color:#119BAF"/>
                    <stop  offset="0.9735" style="stop-color:#04B5C7"/>
                    <stop  offset="1" style="stop-color:#00BED0"/>
                  </linearGradient>
                  <path style="fill:url(#SVGID_2_);" d="M100,41.5c32.3,0,58.5,26.2,58.5,58.5s-26.2,58.5-58.5,58.5S41.5,132.3,41.5,100
                    S67.7,41.5,100,41.5 M100,17.5c-45.6,0-82.5,36.9-82.5,82.5s36.9,82.5,82.5,82.5s82.5-36.9,82.5-82.5S145.6,17.5,100,17.5
                    L100,17.5z"/>
                </g>
              </g>
              <g>
                <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M76.9,112.3h-5.3v-11.5l0.2-7.7h-0.1l-5.6,19.2h-4.8
                  l-5.6-19.2h-0.1l0.2,7.7v11.5h-5.3V87.3H59l3.6,12.8l1.3,5.3h0.1l1.3-5.3l3.6-12.8h8.1V112.3z"/>
                <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M100.2,107.3v5H82V87.3h17.8v5H88v5.1h9.4v4.7H88v5.1H100.2z"
                  />
                <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M124.4,112.3h-6.6l-7.1-13.6L109,95h0l0.1,4.7v12.6h-5.3V87.3
                  h6.6l7.1,13.6l1.7,3.8h0l-0.1-4.7V87.3h5.3V112.3z"/>
                <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M149.5,102.1c0,3.5-0.9,6.2-2.6,7.9c-1.7,1.8-4.3,2.7-7.6,2.7
                  c-3.4,0-5.9-0.9-7.6-2.7c-1.7-1.8-2.6-4.4-2.6-7.9V87.3h6v15c0,1.8,0.3,3.1,1,4c0.7,0.9,1.8,1.3,3.2,1.3c2.9,0,4.3-1.8,4.3-5.4
                  v-15h5.9V102.1z"/>
              </g>
              <g id="Layer_2">
                <g>
                  <circle style="fill:#ED008B;" cx="171" cy="100" r="15.5"/>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <Menu :closeM="closeM" :menuIsOpened="menuIsOpened" v-on:keyup.esc="closeMenu"/>
  </section>
</template>

<script>
import Menu from './Menu.vue'
export default {
  name: 'Header',
  components: {
    Menu
  },
  data(){
    return {
      menuIsOpened: false,
      closeM: this.closeMenu
    }
  },
  mounted(){
    let menuBtnSvg = document.getElementById('Layer_1')
    let menuBtnSvg2 = document.getElementById('Layer_2')
    let btnTimeLineAnim = new TimelineMax({repeat:-1})
    btnTimeLineAnim.timeScale(1.2)
    btnTimeLineAnim
    .to(menuBtnSvg, 1, {scale: 0.82, transformOrigin:"50% 50%", ease: Power0.easeNone} )
    .to(menuBtnSvg, 1, {scale: 1, transformOrigin:"50% 50%", ease: Power0.easeNone} )
    .to(menuBtnSvg2, 1, {scale: 0, transformOrigin:"50% 50%", ease: Power1.easeIn}, '-=2')
    .to(menuBtnSvg2, 1, {scale: 1, transformOrigin:"50% 50%", ease: Power1.easeIn}, '-=1')
  },
  created(){
    window.addEventListener('keydown', (evt)=> {
      evt = evt || window.event;
      var isEscape = false;
      if("key" in evt){
        isEscape = (evt.key == "Escape" || evt.key == "Esc");
      }else{
        isEscape = (evt.keyCode == 27);
      }
      if(isEscape && this.menuIsOpened){
        this.closeMenu();
      }
    });
  },
  methods:{
    changeMenuState(){
      this.menuIsOpened = !this.menuIsOpened
    },
    openMenu(){
      this.changeMenuState()
      document.documentElement.classList.add('overflow_is_active')
      document.body.classList.add('overflow_y_is_active')
      let menu = document.querySelector('.main_menu')
      TweenLite.to(menu, 0.3, {css:{ opacity: 1, pointerEvents: 'auto'}, ease: Power1.easeIn})
    },
    closeMenu(){ 
      document.documentElement.classList.remove('overflow_is_active')
      document.body.classList.remove('overflow_y_is_active')
      let menu = document.querySelector('.main_menu')
      TweenLite.to(menu, 0.3, {css:{ opacity: 0, pointerEvents: 'none'}, ease: Power1.easeOut});
      this.changeMenuState()
    },
    animMenuBtn(){
      let letters = document.getElementsByClassName('menu_letter')
      TweenLite.to(letters, 0.2, {css:{ fill: '#ED008B', stroke:'#ED008B' }, ease: Power1.easeOut})
    },
    animMenuBtnRev(){
      let letters = document.getElementsByClassName('menu_letter')
      TweenLite.to(letters, 0.2, {css:{ fill: '#41354D', stroke:'#41354D' }, ease: Power1.easeIn})
    }
  }
}
</script>
<style>
#menu_btn{
  width: 128px;
  height: 128px;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  outline: none;
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
}
.overflow_is_active{
  position: fixed;
  right: 0;
  left: 0;
  overflow: hidden;
}
.overflow_y_is_active{
  overflow-y: scroll;
}
</style>